import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {Sound} from '../../Sound'
import {UIGameManager} from '../UIGameManager'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Point} from '@colonist/game-mechanic-validators'
import {UIGameExpandContractAnimation} from '../../ui_canvas_engine/animation/UIGameExpandContractAnimation'

export interface UIGameMapHighlightParameters {
    x: number
    y: number
    size: number
    index: number
}

export class UIGameMapHighlightView extends SpriteView {
    private readonly uiGameManager: UIGameManager

    private readonly size: number
    private readonly center: Point
    private readonly animation: UIGameExpandContractAnimation
    readonly highlightedGameElementIndex: number

    constructor(uiGameManager: UIGameManager, parameters: UIGameMapHighlightParameters, container: PIXI.Container, action: () => void, isWhite: boolean = false, shouldHighlightOnlyOnHover: boolean = false) {
        super(parameters.x, parameters.y, parameters.size, parameters.size, container, UIGameMapHighlightView.getTextureForHighlight(isWhite))
        this.uiGameManager = uiGameManager
        this.setClickAction(() => {
            action()
            Sound.playSound(Sound.SoundType.Click)
        })

        this.animation = new UIGameExpandContractAnimation(this)

        this.size = parameters.size
        this.highlightedGameElementIndex = parameters.index
        this.center = new Point(this.x + this.size / 2, this.y + this.size / 2)
        this.zIndex = this.uiGameManager.mapController.mapView.layers.topLayer

        if(isWhite) return
        if(shouldHighlightOnlyOnHover) return
        this.setHoverAction((event) => {
            this.texture = UIGameMapHighlightView.getTextureForHighlight(true)
        }, (event) => {
            this.texture = UIGameMapHighlightView.getTextureForHighlight(false)
        })
    }

    animate() {
        this.animation.start()
    }

    resetAnimation() {
        this.animation.stop()
    }

    displayOnlyOnHover() {
        const onHoverStart = () => this.alpha = 1
        const onHoverEnd = () => this.alpha = 0

        this.alpha = 0
        this.setHoverAction(onHoverStart, onHoverEnd)
    }

    displayAlwaysOn(canAffordAction: boolean) {
        this.alpha = canAffordAction ? 1 : 0
    }

    resetDisplay() {
        const revertedHoverAction = () => this.alpha = 1

        this.alpha = 1
        this.setHoverAction(revertedHoverAction, revertedHoverAction)
    }

    static getTextureForHighlight(isWhite: boolean): PIXI.Texture {
        return isWhite ?
            UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle_white) :
            UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_highlight_circle)
    }
}
